<template>
<div>

        <!------------------------------------- NAME ------------------------------------------------->

        <m-contact-line 
            left_icon="mdi-account" 
            label="Prefix" 
            v-model="contact.name.prefix"
            hide_empty no_right_column disabled
        />

        <m-contact-line 
            :left_icon="showLine(contact.name.prefix) ? 'mdi-none' : 'mdi-account'" 
            label="First Name" 
            v-model="contact.name.first"
            no_right_column disabled
        />

        <m-contact-line 
            label="Middle Name" 
            v-model="contact.name.middle"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            label="Last Name" 
            v-model="contact.name.last"
            no_right_column disabled
        />

        <m-contact-line 
            label="Suffix" 
            v-model="contact.name.suffix"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            label="Phonetic" 
            v-model="contact.name.phonetic"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            label="Nickname" 
            v-model="contact.name.nickname"
            hide_empty
            no_right_column disabled
        />
        
        <m-contact-line 
            label="Label As" 
            hint="If filled out, the contact will show this label throughout the system"
            v-model="contact.name.explicit_label"
            hide_empty
            no_right_column disabled
        />
        
        <!------------------------------------- EMPLOYMENT SUMMARY ------------------------------------------------->

        <m-contact-line 
            left_icon="mdi-domain"
            label="Company" 
            v-model="contact.employment_summary.organization_name"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            label="Job Title" 
            v-model="contact.employment_summary.job_title"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            label="Department" 
            v-model="contact.employment_summary.department"
            hide_empty
            no_right_column disabled
        />

        <!-------------------------------------- PHONE NUMBERS -------------------------------------------------->

        <div
            v-for="(phone, index) in contact.phone_numbers"
            :key="index+'_phone'"
        >
            <m-contact-line 
                left_icon="mdi-phone"
                label="Phone Number" 
                :value="prettyPrintPhone(phone.phone_number)"
                phone_number
                no_right_column disabled
            />

            <m-contact-line 
                label="Label" 
                v-model="phone.label"
                no_right_column disabled
                
            />
        </div>

        <!-------------------------------------- EMAIL ADDRESSES -------------------------------------------------->

        <div
            v-for="(email, index) in contact.email_addresses"
            :key="index+'_email'"
        >
            <m-contact-line 
                left_icon="mdi-email"
                label="Email Address" 
                :value="email.email"
                email
                no_right_column disabled
            />

            <m-contact-line 
                label="Label" 
                v-model="email.label"
                no_right_column disabled
            />
        </div>


        <!-------------------------------------- POSTAL ADDRESSES -------------------------------------------------->

        <div
            v-for="(address, index) in contact.postal_addresses"
            :key="index+'_postal_address'"
        >
            <m-contact-line 
                left_icon="mdi-map-marker"
                label="Address Label" 
                hint="e.g. Home, Office, Warehouse, etc."
                :value="address.label"
                no_right_column disabled
            />

            <m-contact-line label="Address Line 1" v-model="address.address.address_line1" hide_empty no_right_column disabled/>
            <m-contact-line label="Address Line 2" v-model="address.address.address_line2" hide_empty no_right_column disabled/>
            <m-contact-line label="Address Line 3" v-model="address.address.address_line3" hide_empty no_right_column disabled/>
            <m-contact-line label="City" v-model="address.address.city" hide_empty no_right_column disabled/>
            <m-contact-line label="State" v-model="address.address.state" hide_empty no_right_column disabled/>
            <m-contact-line label="Zip Code" v-model="address.address.postal_code" hide_empty no_right_column disabled/>
            <m-contact-line label="Country Code" v-model="address.address.country" hide_empty no_right_column disabled/>

        </div>


        <!-------------------------------------- EXTENDED FIELDS -------------------------------------------------->
        <m-contact-line 
            left_icon="mdi-cake-variant"
            label="Birthday" 
            hint="(MM/DD or MM/DD/YYYY) - e.g. 2/8 for Feb 8th, 2/8/1981 for Feb 8th 1981"
            us_date_with_optional_year
            v-model="contact.birthday"
            hide_empty
            no_right_column disabled
        />

        <!-------------------------------------- OTHER EVENTS -------------------------------------------------->

        <div
            v-for="(event, index) in contact.events"
            :key="index+'_events'"
            
        >
            <m-contact-line 
                left_icon="mdi-calendar"
                label="Event Date" 
                v-model="event.date"
                us_date_with_optional_year
                show_add
                show_delete
                v-on:on-delete="deleteEvent(index)"
                v-on:on-add="addEvent()"
                no_right_column disabled
            />

             <m-contact-line 
                label="Label" 
                v-model="event.label"
                hide_empty
                no_right_column disabled
            />
        </div>

        <!-------------------------------------- MORE EXTENDED FIELDS -------------------------------------------------->

        <m-contact-line 
            left_icon="mdi-link"
            label="Website" 
            v-model="contact.website"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            left_icon="mdi-cog"
            label="Custom Field" 
            v-model="contact.custom_field"
            hide_empty
            no_right_column disabled
        />

        <m-contact-line 
            left_icon="mdi-file"
            label="Notes" 
            v-model="contact.notes"
            hide_empty
            no_right_column disabled
        />
</div>
</template>

<script>

const E164 = require('@/js/E164.js');
const _ = require('lodash');


export default {
    props: {
        contact: {
            type: Object,
            default: function () { return {}; }
        },
    },

    data() {
        return {
            
        }
    },

    methods: 
    {
        showLine(value)
        {
            if ( value == null ) return false;
            if ( value.trim().length == 0 ) return false;
            return true;
        },

        prettyPrintPhone(value)
        {
            return E164.prettyPrintUsPhoneNumber(value);
        }
    },
}

</script>

<style lang="scss" scoped>
.left_icon_column
{
    min-width: 40px;
}
.right_icon_column
{
    min-width: 60px;
}
</style>